import { Box, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  OverviewCard,
  PageTitleAndSubTitle,
  Breadcrumbs,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import {
  formatDiseaseTotalCost,
  formatMemberValues,
  MemberValues,
  TotalCost,
} from '../../core-utils/helper-utils/summaryReportHelper';
import properties from '../../core-utils/properties';
import Loader from '../../_components/molecules/Loader';
import diseasePrevalencePageConstants from '../../core-utils/messages/diseasePrevalencePageConstants';
import { useNavigate } from 'react-router-dom';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { useStores } from '../../stores';
import DiseasePrevalenceTable from '../../_components/organisms/DiseasePrevalenceTable';
import ReportsModal from '../../_components/organisms/ReportsModal';
import { ENROLLMENT_METRICS, PLAN_PERFORMANCE } from '../../core-utils/routes';
import TabSelection from '../../_components/molecules/TabSelection';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';
import { getCohortValue } from '../../core-utils/helper-utils/overviewCardHelper';
import OverviewCardTooltipContent from '../../_components/atoms/OverviewCardTooltipContent';
import useTotalEligible from '../../core-utils/custom-hooks/TotalEligible';
import DateFilter from '../../_components/molecules/DateFilter';
import usePlanDates from '../../core-utils/custom-hooks/PlanDates';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import { observer } from 'mobx-react';
import { downloadPdf } from '../../core-utils/helper-utils/downloadPdfHelper';
import Snackbar from '../../_components/atoms/Snackbar';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import componentConstants from '../../core-utils/messages/componentConstants';
import AiSummaryCard from '../../_components/molecules/AiSummaryCard';
import allScreenLabel from '../../core-utils/messages/screenNamesForPrompts';
import {
  checkUserAccess,
  UserAccessConstants,
} from '../../core-utils/helper-utils/userAccess';
import CohortDetailsModal from '../../_components/organisms/CohortDetailsModalNew';
import CohortFilterBar from '../../_components/molecules/CohortFilterBar';
import { useCohortOnPageLoad } from '../../core-utils/custom-hooks/useCohortPageOnLoad';
import { useCohortModal } from '../../core-utils/custom-hooks/useCohortModal';

export interface DiseasePrevalenceByCondition {
  label: string;
  value: string;
  svalue: string;
}

export interface DiseasePrevalenceByConditionAPIResponse {
  data: any;
  status: any;
}

export interface DiseasePrevalenceByConditionMain {
  label: string;
  svalue: string;
  data: DiseasePrevalenceByCondition[];
}

export interface MemberHealthConditionProps {
  totalMembers: number | string;
  mentalCondition: number | string;
  physicalCondition: number | string;
  both: number | string;
  neither: number | string;
}

export interface PrevalenceByGenderProps {
  totalMembers: number;
  mentalCondition: number;
  physicalCondition: number;
  both: number;
  neither: number;
}

export interface SummaryPageProps {}

export const getDiseaseSubTitle = () => {
  return (
    <Typography
      fontSize={'14px'}
      lineHeight="177%"
      textColor={patientAccessTheme.palette.text.mediumemphasis}
      fontType="regular"
    >
      Cost and utilization by diagnosis and condition using{' '}
      <a
        href="https://www.icd10data.com/"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: patientAccessTheme.palette.primary.main,
          textDecoration: 'underline',
        }}
      >
        ICD-10 classifications
      </a>{' '}
      from CMS/NCHS; costs shown reflect medical claims only.
    </Typography>
  );
};
const DiseasePrevalencePage: React.FC<SummaryPageProps> = observer(({}) => {
  const useStyles = makeStyles()({
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: '40px 0px 66px 63px',
    },
  });

  const { classes } = useStyles();
  const snackBarMessages = componentConstants.ORGANISMS.REPORTS_MODAL;

  const messages = diseasePrevalencePageConstants.DISEASE_PREVALENCE_PAGE;
  const screenName = allScreenLabel;

  const [loading, setLoading] = useState<boolean>(false);
  const [totalCost, setTotalCost] = useState<TotalCost>({
    totalCost: '$0.00',
    totalRx: '$0.00',
    totalMedical: '$0.00',
  });
  // const [costValues, setCostValues] = useState<CostValues>({
  //   rx: '$0.00',
  //   medical: '$0.00',
  //   total: '$0.00',
  // });
  const [memberValues, setMemberValues] = useState<MemberValues>({
    members: '0',
    employees: '0',
    dependents: '0',
  });

  const [
    diseasePrevalenceTableData,
    setDiseasePrevalenceTableData,
  ] = useState<any>({});
  const [openReportsModal, setOpenReportsModal] = useState(false);
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
    false,
  );
  const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
    false,
  );
  const [activeAskAi, setActiveAskAi] = useState<boolean>(false);
  const [aiLoading, setAiLoading] = useState<boolean>(false);
  const [aiSummaryData, setAiSummaryData] = useState<
    { title: string; description: string }[]
  >([]);
  const { open, openModal, closeModal, isEditMode } = useCohortModal();

  //snackbar
  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
    if (!recommendationFetched) {
      getRecommendationsData(
        employerGroupStore?.employerGroupResponseData?.eg_nid,
        messages.TITLE,
        recommendedTabStore,
        setRecommendationLoading,
      );
      setRecommendationFetched(true);
    }
  };

  const handleDiseaseDropDownList = (diseasePrevalenceTableData: any) => {
    const localDiseasesDropDownList: string[] = [];
    const localDiseasesMembersMap: Map<string, any> = new Map<
      string,
      string[]
    >();
    diseasePrevalenceTableData?.map((diseaseSummaryObject: any) => {
      localDiseasesDropDownList.push(
        diseaseSummaryObject?.chronicDiseaseGroupName,
      );
      localDiseasesMembersMap.set(
        diseaseSummaryObject?.chronicDiseaseGroupName,
        {
          memberList: diseaseSummaryObject?.disease_member_list,
          medicalCost: diseaseSummaryObject?.medicalCost,
          rxCost: diseaseSummaryObject?.rxCost,
          pmpm: diseaseSummaryObject?.pmpm,
        },
      );
      diseaseSummaryObject?.individualDiseases?.map(
        (individualDiseaseSummary: any) => {
          localDiseasesDropDownList.push(
            individualDiseaseSummary?.chronicDiseaseName,
          );
          localDiseasesMembersMap.set(
            individualDiseaseSummary?.chronicDiseaseName,
            {
              memberList: individualDiseaseSummary?.disease_member_list,
              medicalCost: individualDiseaseSummary?.medicalCost,
              rxCost: individualDiseaseSummary?.rxCost,
              pmpm: individualDiseaseSummary?.pmpm,
            },
          );
        },
      );
    });
    diseasePrevalenceStore.setDiseasesDropDownList(localDiseasesDropDownList);
    diseasePrevalenceStore.setDiseasesMembersMap(localDiseasesMembersMap);
  };

  const handleAskAi = () => {
    setActiveAskAi(true);
    getAiDiseasePrevalenceSummary();
  };
  const getTotalCost = async (member_unique_id_list: string[]) => {
    if (member_unique_id_list?.length === 0) {
      return;
    }
    await axios
      .post(properties.aiqBaseUrl + properties.summaryBaseUrl, {
        ...payload,
        claim_id_list: [],
        member_unique_id_list: member_unique_id_list || [],
        max_claim_date:
          employerGroupStore?.employerGroupResponseData?.max_claim_date,
      })
      .then((res) => {
        if (res?.status === 200) {
          setMemberValues(formatMemberValues(res?.data?.data));
          // setCostValues(formatCostValues(res?.data?.data));
        }
      })
      .catch((ex) => {
        return ex;
      });
  };

  const getDiseasePrevalenceTableData = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.diseasePrevalence +
          properties.prevalenceSummary,
        {
          ...payload,
          claim_id_list: [],
          member_unique_id_list: cohortDetailsStore.memberUniqueIdList || [],
          max_claim_date:
            employerGroupStore?.employerGroupResponseData?.max_claim_date,
        },
      )
      .then(async (res) => {
        if (res?.status === 200) {
          setDiseasePrevalenceTableData(res?.data?.data);
          handleDiseaseDropDownList(res?.data?.data?.prevalenceSummary);
          await Promise.all([
            setTotalCost(
              formatDiseaseTotalCost(res?.data?.data?.prevalenceSummary, 2),
            ),
            // setCostValues(
            //   formatDiseaseCostValues(res?.data?.data?.prevalenceSummary),
            // ),
            getTotalCost(res?.data?.data?.total_members_list),
          ]);
        }
      })
      .catch((ex) => {
        return ex;
      });
  };
  const getDisPrevalenceCohortMembers = async (): Promise<{
    noOfMemberIds: number;
    member_unique_ids: string[];
  }> => {
    try {
      const res = await axios.post(
        properties.aiqBaseUrl +
          properties.diseasePrevalence +
          properties.getDisPrevalenceCohortMembers,
        {
          ...payload,
          claim_id_list: [],
          member_unique_id_list: cohortDetailsStore.memberUniqueIdList || [],
          max_claim_date:
            employerGroupStore?.employerGroupResponseData?.max_claim_date,
        },
      );

      if (res?.status === 200) {
        const data = res?.data?.data;
        return {
          noOfMemberIds: data?.noOfMemberIds || 0,
          member_unique_ids: data?.member_unique_ids || [],
        };
      }

      return { noOfMemberIds: 0, member_unique_ids: [] };
    } catch (error) {
      console.error(error);
      return { noOfMemberIds: 0, member_unique_ids: [] };
    }
  };

  const recommendedTabStore = useStores().recommendedTabStore;
  const navigate = useNavigate();

  const handleDiseaseCategory = (
    diseaseCategory: string,
    memberList: string[],
    isDiseaseGroup: boolean,
    totalCost: any,
  ) => {
    recommendedTabStore?.setCategoryToBeCalled(
      messages.PREVALENCE_BY + ' ' + diseaseCategory,
    );
    navigate(`/disease-prelavence/${encodeURIComponent(diseaseCategory)}`, {
      state: {
        memberList,
        isDiseaseGroup,
        totalCost,
      },
    });
  };

  const getAllCharts = async () => {
    setLoading(true);
    isPlanDatesFetched &&
      (await Promise.all([getDiseasePrevalenceTableData(), getTotalEligible()])
        .then(() => {
          setLoading(false);
        })
        .finally(() => {
          setLoading(false);
        }));
  };

  const getAiDiseasePrevalenceSummary = async () => {
    try {
      setAiLoading(true);

      // ✅ Clean Disease Prevalence Data
      const cleanPrevalenceData = diseasePrevalenceTableData?.prevalenceSummary?.map(
        (item: any) => ({
          diseaseGroupName: item?.diseaseGroupName,
          totalCost: item?.totalCost,
          memberCount: item?.memberCount,
          prevalenceRate: item?.prevalenceRate,
          pmpm: item?.pmpm,
          averageCost: item?.averageCost,
          highCost: item?.highCost,
          medicalPercent: item?.medicalPercent,
          rxPercent: item?.rxPercent,
        }),
      );

      const cleanMemberCostData = {
        members: memberValues?.members,
        employees: memberValues?.employees,
        dependents: memberValues?.dependents,
      };

      // ✅ Prepare API response object
      const apiResponses = {
        title_1: diseasePrevalenceTableData?.highestPrevalenceRate,
        title_2: cleanPrevalenceData,
        title_3: cleanMemberCostData,
      };
      let resultArray = []; // ✅ default fallback

      const requestBody = {
        screenName: screenName.DISEASE_PRELAVENCE,
        eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
        incurredStartDate,
        incurredEndDate,
        paidStartDate,
        paidEndDate,
        apiData: apiResponses,
      };

      const response = await axios.post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.getAiSummary,
        requestBody,
      );

      if (response?.status === 200) {
        // ✅ Safe extraction
        resultArray = response?.data?.data?.data?.result || [];
        setAiSummaryData(Array.isArray(resultArray) ? resultArray : []);
      }
    } catch (error: any) {
      console.error(' Error:', error);
      handleOpenSnackBar(error, 'error', 6000);
      setAiSummaryData([]);
    } finally {
      setAiLoading(false);
    }
  };

  const employerGroupStore = useStores().employerGroupStore;
  const diseasePrevalenceStore = useStores().diseasePrevalenceStore;
  const quaterlyReportStore = useStores().quaterlyReportStore;
  const {
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    isPlanDatesFetched,
    aggregationParameter,
  } = quaterlyReportStore;
  const loginPageStore = useStores().loginPageStore;
  const cohortDetailsStore = useStores().cohortDetailsStore;

  const { getPlanDates, loading: isPlanDatesLoading } = usePlanDates();
  const payload = useAPIPayload();
  const { totalResults, memberIds, isInitializing } = useCohortOnPageLoad({
    fetchTotalResults: () => getDisPrevalenceCohortMembers(),
    enabled:
      isPlanDatesFetched &&
      !!employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
  });

  const {
    overAllEnrolled,
    overallTotalCost,
    getTotalEligible,
  } = useTotalEligible(
    aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
    aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
    employerGroupStore,
  );

  useEffect(() => {
    if (isInitializing) {
      return;
    }
    getAllCharts();
  }, [
    isInitializing,
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    cohortDetailsStore.memberUniqueIdList,
  ]);

  useEffect(() => {
    const fetchPlanDates = async () => {
      if (!isPlanDatesFetched) {
        await getPlanDates();
      }
    };
    if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
      return;
    }
    fetchPlanDates();
  }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);

  //click Here Navigation Functions -
  const pushToEnrollemntMetrics = () => {
    navigate(ENROLLMENT_METRICS);
  };
  const pushToPlanPerformance = () => {
    navigate(PLAN_PERFORMANCE);
  };

  const SummaryCards = () => {
    const useStyles = makeStyles()({
      root: {
        display: 'flex',
        flexDirection: 'column',
      },
    });

    const { classes } = useStyles();
    return (
      <Grid container className={classes.root}>
        <Grid style={{ display: 'flex', marginBottom: '18px' }}>
          <Grid style={{ width: '1182px' }}>
            <CohortFilterBar />
          </Grid>
          {false && (
            <Grid style={{ marginRight: '24px' }}>
              <OverviewCardTooltipContent
                type={'member'}
                cohortMemberValues={memberValues}
                totalMemberValues={{
                  dependents: overAllEnrolled.dependents,
                  employees: overAllEnrolled.employees,
                  members: overAllEnrolled.totalCount,
                }}
                overviewCard={
                  <OverviewCard
                    title={messages.SUMMARY_CARDS.MEMBERS}
                    value={getCohortValue(
                      memberValues.members,
                      overAllEnrolled.totalCount,
                    )}
                    rootStyles={{
                      width: '176px',
                      fontWeight: 600,
                      fontSize: ' 24px',
                    }}
                    showClickHere
                    handleClickHere={pushToEnrollemntMetrics}
                  />
                }
              />
            </Grid>
          )}
          {false && (
            <Grid style={{ marginRight: '24px' }}>
              <OverviewCardTooltipContent
                type={'cost'}
                cohortCostValues={{
                  medical: totalCost.totalMedical,
                  rx: totalCost.totalRx,
                  total: totalCost.totalCost,
                }}
                totalCostValues={{
                  medical: overallTotalCost.totalMedical,
                  rx: overallTotalCost.totalRx,
                  total: overallTotalCost.totalCost,
                }}
                overviewCard={
                  <OverviewCard
                    title={messages.SUMMARY_CARDS.TOTAL_COST}
                    value={getCohortValue(
                      (totalCost?.totalCost).toString(),
                      overallTotalCost.totalCost,
                    )}
                    rootStyles={{
                      width: '216px',
                    }}
                    labelsMinWidth="72px"
                    showClickHere
                    handleClickHere={pushToPlanPerformance}
                  />
                }
              />
            </Grid>
          )}
        </Grid>
        <Grid style={{ display: 'flex' }}>
          <DiseasePrevalenceTable
            data={diseasePrevalenceTableData?.prevalenceSummary}
            handleDiseaseCategory={handleDiseaseCategory}
            highestPrevalenceRate={
              diseasePrevalenceTableData?.highestPrevalenceRate
            }
            handleEpisodeCategory={function () {}}
          />
        </Grid>
      </Grid>
    );
  };

  const [loader] = useState<any>(<Loader />);
  const pathStore = useStores().pathStore;
  const getPath = () => {
    if (pathStore.path.length !== 0) {
      return pathStore.path;
    } else {
      return [];
    }
  };

  return (
    <>
      {isPlanDatesLoading || loading || isInitializing ? (
        loader
      ) : (
        <Grid container className={classes.root}>
          {getPath().length !== 0 && (
            <Grid style={{ marginBottom: '20px' }}>
              <Breadcrumbs itemList={getPath()} />
            </Grid>
          )}

          <Grid
            style={{
              marginBottom: '18px',
              width: '1182px',
              position: 'relative',
            }}
          >
            <PageTitleAndSubTitle
              title={
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography
                    fontSize="18px"
                    lineHeight="22px"
                    textColor={patientAccessTheme.palette.text.highemphasis}
                    fontType="semiBold"
                  >
                    {messages.TITLE}
                  </Typography>
                  <Typography
                    fontSize="17px"
                    lineHeight="21px"
                    textColor={patientAccessTheme.palette.text.mediumemphasis}
                    fontType="semiBold"
                    margin="0px 8px 0px 0px"
                  >
                    for
                  </Typography>
                  <DateFilter />
                </Box>
              }
              subTitle={getDiseaseSubTitle()}
              showDownloadButton={true}
              // downloadButtonAction={() => setOpenReportsModal(true)}
              showAskAi={true}
              askAiAction={handleAskAi}
              downloadButtonAction={() => {
                downloadPdf(
                  'diseasePrevalenceReport',
                  {
                    employer:
                      employerGroupStore?.employerGroupResponseData
                        ?.employer_group_name,
                    member_unique_id_list:
                      cohortDetailsStore.memberUniqueIdList || [],
                    claim_id_list: [],
                    maxClaimDate:
                      employerGroupStore?.employerGroupResponseData
                        ?.max_claim_date,
                    ...payload,
                  },
                  handleOpenSnackBar,
                  'open',
                );
                handleOpenSnackBar(
                  snackBarMessages.SNACKBAR_MESSAGES.OPEN_REPORT,
                  'info',
                  6000,
                );
              }}
              showQueryDataButton={checkUserAccess(
                UserAccessConstants.COHORT_DETAILS,
                loginPageStore.userResponse.role.name,
                loginPageStore.userFeatures,
              )}
              queryButtonText={
                cohortDetailsStore.cohortDetailsList?.length > 0 &&
                cohortDetailsStore.cohortDetailsList[0].category !== ''
                  ? 'Edit Cohort'
                  : 'Add Cohort'
              }
              queryDataAction={() => {
                if (
                  checkUserAccess(
                    UserAccessConstants.COHORT_DETAILS,
                    loginPageStore.userResponse.role.name,
                    loginPageStore.userFeatures,
                  )
                ) {
                  openModal();
                }
              }}
              subTitleStyles={{ width: '700px' }}
            />

            <TabSelection
              selectedTabIndex={selectedTabIndex}
              setSelectedTabIndex={handleSelectedIndex}
              recommendationFetched={recommendationFetched}
            />
          </Grid>
          <Grid>
            {selectedTabIndex === 0 && <SummaryCards />}
            {selectedTabIndex === 1 && (
              <RecommendationsTab
                recommendationLoading={recommendationLoading}
                isInternalPage={true}
              />
            )}
          </Grid>
        </Grid>
      )}
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
      <AiSummaryCard
        open={activeAskAi}
        onClose={() => {
          setActiveAskAi(false);
          setAiSummaryData([]);
        }}
        aiSummaryData={aiSummaryData}
        loading={aiLoading}
      />
      <ReportsModal
        open={openReportsModal}
        setOpen={setOpenReportsModal}
        startDate={incurredStartDate}
        endDate={incurredEndDate}
      />
      <CohortDetailsModal
        open={open}
        handleClose={closeModal}
        totalResults={totalResults}
        isEditMode={isEditMode}
        existingMemberUniqueIds={memberIds}
      />
    </>
  );
});
export default DiseasePrevalencePage;
